import React from 'react';
import { Box, Text } from '@razorpay/blade/components';

export const ReportMetaBar = ({
  page,
  limit,
  totalRows,
  preparedAt,
  isRealTime,
  rightContent,
}: {
  page: number;
  limit: number;
  totalRows: number;
  preparedAt?: string | null;
  isRealTime: boolean;
  rightContent?: React.ReactNode;
}) => (
  <Box
    display="flex"
    justifyContent="space-between"
    alignItems="center"
    minHeight="68px"
    padding={['spacing.5', 'spacing.8']}>
    <Box display="flex" gap="spacing.5">
      <Text weight="semibold" color="surface.text.gray.muted">
        Showing {(page - 1) * limit + 1}-{Math.min(page * limit, totalRows)} of {totalRows}
      </Text>
    </Box>
    <Box display="flex" gap="spacing.4" alignItems="center">
      {!isRealTime && preparedAt && (
        <Text variant="caption" size="small">
          Last generated at: {preparedAt.split(' ')[0] + ' | ' + preparedAt.split(' ')[1]}
        </Text>
      )}
      {rightContent}
    </Box>
  </Box>
);
